import { ref, watch,onMounted, computed } from '@vue/composition-api'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/axios'
import store from '@/store'
import debounce from 'lodash/debounce'
import { useRouter } from '@core/utils/utils'
import { is } from 'vee-validate/dist/rules'

export default function useLinksList() {
  // Use toast
  const toast = useToast()

  const { route } = useRouter()

  const refLinkListTable = ref(null)
  
  const isFenomen = store.getters['user/isFenomen']

  // Table Handlers
  const tableColumnCopy = [
    { key: 'id', sortable: true },
    { key: 'image', label: 'Görsel', sortable: false },
    { key: 'type', label: 'Kaynak', sortable: false },
    { key: 'platform', label: 'Platform', sortable: false },
    { key: 'campaign_name', label: 'Paylaşım', sortable: true },
    { key: 'username', label: 'Fenomen', sortable: true },
    { key: 'event_count',label:'Ziyaret', sortable: false },
    { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
    { key: 'order_count',label:'Sipariş Adedi', sortable: false },
    { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
    { key: 'status', label: 'Durum', sortable: true},
    { key: 'actions', label: 'İşlem'},
  ]
  const tableColumns = ref([...tableColumnCopy])

  
  const perPage = ref(store.state.appConfig.perPage)
  const totalLinks = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const fenomenList = ref([])
  const getInfId = ref(null)
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const isFirstLoad = ref(true)
  const additionalParams = ref({})
  const isLoading = ref(false)
  const viewType = ref('active')

  let filterTypes = []
  
  const filterOptions = ref( {
    is_internal_domain: null,
    status: null,
  })

  const multiLinks = ref(false)


  const dataMeta = computed(() => {
    const localItemsCount = refLinkListTable.value ? refLinkListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalLinks.value,
    }
  })
  const refetchData = () => {
    refLinkListTable.value.refresh()
  }

  watch([currentPage, perPage, roleFilter, planFilter, statusFilter, getInfId, additionalParams, filterOptions, multiLinks, viewType], () => {
    if(isFirstLoad.value){
      multiLinks.value = additionalParams.value && additionalParams.value.multiLinks ? true : false
      
      if (multiLinks.value) {
        tableColumns.value = [...tableColumnCopy]
        tableColumns.value.splice(1, 1)
        tableColumns.value.splice(3, 0, { key: 'links_count', label: 'PAYLAŞIM ADEDİ', sortable: true },);
      }
    }else{
      additionalParams.value.multiLinks = multiLinks.value ? 1 : 0
    }

    if (!multiLinks.value) {
      tableColumns.value = [...tableColumnCopy]
    } else {
      tableColumns.value = [...tableColumnCopy]
      tableColumns.value.splice(1, 1)
      tableColumns.value.splice(4, 0, { key: 'links_count', label: 'PAYLAŞIM ADEDİ', sortable: true },);
    }
    if (!isFirstLoad.value) { // İlk yüklemede değilse çalışsın
      refetchData()
    }
    isFirstLoad.value = false;
    
  })
  const debouncedRefetch = debounce(() => {
    refetchData()
  }, 2000)

  watch(searchQuery, () => {
    if (!isFirstLoad.value) {
      debouncedRefetch();
    }
    isFirstLoad.value = false
  })
  const desiredFields = ['id', 'name_surname', 'link_disi_odeme_orani', 'link_ici_odeme_orani', 'payment_amount']

  const fetchFenomenOptions = async () => {
    try {
      const response = await axiosIns.get('/user', {
        params: { 
          user_type: 'influencer',
          fields: desiredFields.join(','), 
          all: true,
         }
      })
      fenomenList.value = response.data.data.map(fenomen => ({
        label: fenomen.name_surname,
        value: fenomen.id,
        link_disi_odeme_orani: fenomen.link_disi_odeme_orani,
        link_ici_odeme_orani: fenomen.link_ici_odeme_orani,
        payment_amount: fenomen.payment_amount,
      }))
    } catch (error) {
      console.error('Error fetching fenomen options:', error)
    }
  }
  
  const fetchLinks = (ctx, callback) => {

    // Filter objesini oluştur
additionalParams.value.filter ??= {}

// filterOptions içindeki tüm filtreleri işle
Object.entries(filterOptions.value).forEach(([key, value]) => {
  if (value !== null && value !== undefined && value !== '') {
    additionalParams.value.filter[key] = value
  } else {
    delete additionalParams.value.filter[key]
  }
})

// Görünüm türüne göre filtreleri ayarla
if (viewType.value === 'archive') {
  additionalParams.value.filter.is_archived = 1
  additionalParams.value.filter.is_deleted = 0
} else if (viewType.value === 'trash') {
  additionalParams.value.filter.is_deleted = 1
  additionalParams.value.filter.is_archived = 0
} else {
  additionalParams.value.filter.is_archived = 0
  additionalParams.value.filter.is_deleted = 0
}

// Filter boşsa kaldır
if (Object.keys(additionalParams.value.filter).length === 0) {
  delete additionalParams.value.filter
}



    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      multiLinks: multiLinks.value ? 1 : 0,
      sortDesc: isSortDirDesc.value,
      infId: Array.isArray(getInfId.value)
        ? getInfId.value.join(',')
        : getInfId.value,
      ...additionalParams.value
    }
    if(route.value.name=='links' || route.value.name=='campaign'){
      params.source = 'list'
    }
    axiosIns
    .get('/link', { params })
    .then(response => {
      const { Links, total } = response.data.data
      callback(Links)
      totalLinks.value = total
    })
    .catch(error => {
      // 401 hatası değilse uyarı göster
      if (!error.response || error.response.status !== 401) {
        toast({
          component: ToastificationContent,
          props: {
            title: error.response.data.error || 'Bağlantılar yüklenirken hata oluştu',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
      // 401 hatası durumunda hiçbir şey yapma (çünkü axios interceptor tarafında hallediliyor)
    })
  }

  onMounted(() => {
    if(!getInfId.value && !isFenomen){
      fetchFenomenOptions()
    }
  })

  return {
    fetchLinks,
    fenomenList,
    tableColumns,
    perPage,
    currentPage,
    totalLinks,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    getInfId,
    viewType,
    isSortDirDesc,
    refLinkListTable,
    additionalParams,
    filterOptions,
    multiLinks,
    refetchData,
    isLoading

  }
}
